module.exports = __webpack_public_path__ + "img/badge-list-thumb-118.d562e065.png";